<template>
  <CBadge :color="badgeColor">{{ label }}</CBadge>
</template>

<script>
export default {
  name: 'ImportHistoryStatusBadge',
  props: {
    status: { type: String, default: '' }
  },
  computed: {
    normalizedStatus() {
      return (this.status || '').toString().trim().toLowerCase()
    },
    label() {
      const labels = {
        in_progress: 'En progreso',
        completed: 'Completada',
        completed_with_observations: 'Completada con observaciones',
        failed: 'Fallida',
        reverted: 'Revertida',
        reverted_partially: 'Revertida parcialmente',
        reversal_failed: 'Reversión fallida',
      }

      return labels[this.normalizedStatus] || this.status || 'Sin estado'
    },
    badgeColor() {
      const colors = {
        in_progress: 'warning',
        completed: 'success',
        completed_with_observations: 'info',
        failed: 'danger',
        reverted: 'dark',
        reverted_partially: 'secondary',
        reversal_failed: 'danger',
      }

      return colors[this.normalizedStatus] || 'light'
    }
  }
}
</script>
